import { forwardRef, useImperativeHandle, useRef } from 'react'
import { SIDRender, SLowcodeList } from 'shj-components'
import config from './config'
import { apiData2Table } from '@/utils/data'
import { TabComponentInterface } from '../../../index.d'
import { salesWorkPage } from '@/services/saleOpServices'
import { useNavigate, useParams } from 'react-router-dom'
import CheckThePhone from '@/components/CheckThePhone'
import { Tag } from 'antd'

const Clue = forwardRef<TabComponentInterface>((_, ref) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const listRef = useRef<any>()

  // 暴露设置列弹窗的打开方法
  useImperativeHandle(ref, () => ({
    openSettingModal: () => {
      listRef.current?.openSetting?.()
    },
  }))

  // 获取线索列表
  const fetchList = ({ current, pageSize }) => {
    return new Promise((resolve, reject) => {
      try {
        salesWorkPage({
          params: { pageId: current, pageSize },
          data: { customerId: id, filterStatusFlag: false },
        }).then((res: any) => {
          resolve(apiData2Table(res))
        })
      } catch (error) {
        reject({ success: false })
      }
    })
  }

  const extension = {
    request: { fetchList },
    events: {},
    // auth: authMap,
    status: {},
    customRender: {
      // 线索ID渲染
      clueIdRender(text: string, record: Record<string, any>) {
        return (
          <SIDRender
            id={text}
            onClick={() => navigate(`/saleOp/salesWorkBench/salesWorkBenchDetail/${record.id}`)}
          />
        )
      },
      // 手机号渲染
      checkPhoneRender(text: any, record: Record<string, any>) {
        return <CheckThePhone clueId={record.id} initValue={text} auth="clueDispatchViewPhone" />
      },
      // 状态渲染
      statusRender(_, record: Record<string, any>) {
        return <Tag color="magenta">{record.statusName}</Tag>
      },
    },
  }

  return (
    <>
      <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} />
    </>
  )
})

export default Clue
